import * as React from "react";
//import { Link } from "gatsby"

function Card(props) {
    return(
        <div className="bg-offwhite shadow w-96 h-72 flex flex-col justify-evenly items-center text-black rounded-xl px-4 py-3">
            <p>{props.ph}</p>
            <h1 className="title font-dokdo text-3xl">{props.title}</h1>
            <body className="description font-overpass text-sm">{props.description}</body>
        </div>
    )
}

export default Card